var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14C1 12.3431 2.34315 11 4 11H5.17687C5.97912 11 6.70374 10.5206 7.01753 9.78228L10.3831 1.86318C10.6056 1.33981 11.1192 1 11.6879 1C13.3847 1 14.7015 2.48022 14.5041 4.16543L14.1337 7.32541C14.0293 8.21693 14.7259 9 15.6235 9H20.0228C22.0159 9 23.4549 10.9077 22.9074 12.8242L20.6217 20.8242C20.2537 22.1121 19.0765 23 17.7371 23H4C2.34315 23 1 21.6569 1 20V14Z",
    fill: "#FFEBEB",
    stroke: "#F25858",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeActive);
export default __webpack_public_path__ + "static/media/like_active.2839e0b63c92fbb23eb92fc4147717ad.svg";
export { ForwardRef as ReactComponent };